module.exports = __webpack_public_path__ + "assets/img/Coolabah-Turf-Article.390d0040.jpg";